import requests from "./httpService";

const SchoolFoodMenuService = {
  addMenu(body) {
    return requests.post("/school-food-menu/add", body);
  },

  updateMenu(id, body) {
    return requests.put(`/school-food-menu/${id}`, body);
  },

  deleteMenu(id) {
    return requests.delete(`/school-food-menu/${id}`);
  },

  listBySchool(schooleId, includeInactive = false, bypassCache = false) {
    const cacheParam = bypassCache ? `&_=${Date.now()}` : "";
    return requests.get(
      `/school-food-menu/school/${schooleId}?includeInactive=${includeInactive ? "true" : "false"}${cacheParam}`
    );
  },

  // Parent module can call this without schooleId because auth already carries it.
  getParentActive(date, moduleType = "MASTER") {
    const params = [];
    if (date) params.push(`date=${encodeURIComponent(date)}`);
    if (moduleType) params.push(`moduleType=${encodeURIComponent(moduleType)}`);
    const query = params.length ? `?${params.join("&")}` : "";
    return requests.get(`/school-food-menu/parent/active${query}`);
  },
};

export default SchoolFoodMenuService;
